<template>
    <div id="app" class="application">
        <div class="container">
            <nav class="nav">
                <div class="grid-flex">
                    <div class="col-md-5 col-sm-12 nav__logo">
                        <router-link :to="{ name: 'Frontpage'}">
                            <SomeIcon class="icon logo"/>
                        </router-link>
                    </div>
                    <!-- {{ $route.name }} -->
                    <div class="col-md-7 col-sm-12 nav__menu">
                        <!-- <slider-navigation></slider-navigation> -->
                        <div class="swiper-scrollbar" slot="scrollbar"
                             :style="(routeName === 'Portfolio') ? 'opacity:0;' : ''"></div>
                        <a href="#" @click="openAbout">about</a>
                    </div>
                </div>
            </nav>
            <transition name="page" mode="out-in">
                <router-view/>
            </transition>
            <footer class="footer grid-flex">
                <div class="footer-copy">
                    © Copyright 2018 · Malwina Wachulec ·  Designed by <a href="https://weareunwind.com"
                                                                          target="_blank">Unwind</a>
                </div>
                <div class="footer-el">
                    <a href="#" class="bigger mobile-only" @click="openAbout">about</a>
                    <a href="https://www.instagram.com/malwina_wachulec/" target="_blank" class="bigger">instagram</a>
                </div>
            </footer>
            <div class="about" style="display:none;">
                <div class="grid-flex">
                    <div class="col-md-6 col-sm-12">
                        <div class="about__logo" @click="closeAbout">
                            <svg class="about__logo-el" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 194.9 203.7" style="enable-background:new 0 0 194.9 203.7;" xml:space="preserve">
                  <g>
                    <path d="M194.6,79.3l-0.3-1.5l-1.3,0.7c-2.4,1.4-4.9,2.3-7.5,3.3c-1.6,0.6-3.3,1.2-5,2l-5.7-1.2l-25-16.7
                      c16.1-11.5,26.6-30.6,27.4-50.2l0-0.9l-0.9-0.1c-17.3-2-34.9,0.2-51.1,6.5c-1.1-4.9-3.3-8.7-6.2-11.2l-0.4-0.4
                      c-7.3-7.2-17.2-10.6-28-9.4c-7.9,0.9-13.8,3.3-19.2,7.9c-5.3,4.5-8.2,10.7-11.3,17.7c-15-5.8-32.1-6.6-47.4-1.6
                      c-1.3-2.7-4.8-4.1-7.6-3.7c-1.5,0.2-3.1,1.2-4,2.5c-0.9,1.2-1.3,2.7-1.2,4.1c0.1,1.7,0.9,3.4,2.1,4.5c0,2,0.1,8.9,3.4,16.4
                      c3.3,7.6,10.6,17.3,26.4,21.2c-1.4,0.9-2.7,2.2-3.4,3.8c-0.5,1-0.8,2.1-1,3.2c-0.2,1.1-0.1,2.4,0.2,3.5c0.7,2.4,2.7,4.1,4.7,5
                      l0.3,0.1l0,0l-0.2,0.2c-0.4,0.4-0.8,0.7-1.2,1.2c-1.5,1.6-2.6,3.7-2.9,5.9c-0.3,2.2,0.3,4.6,1.6,6.3c1.3,1.8,3.2,2.9,5.1,3.4
                      c2.6,0.7,5.2,0.5,7.5-0.3l0.9-0.3c0.2-0.1,0.5-0.2,0.5-0.2c0,0,0,0.1,0,0.2c0.1,0.6,0.2,1.2,0.4,1.7c0.3,1.1,0.8,2.1,1.5,3
                      c0.3,0.5,0.7,0.9,1.2,1.2c0.4,0.3,0.8,0.6,1.3,0.9c0.6,0.4,1.2,0.6,1.8,0.9c0.4,4,0.8,7.2,1.3,9.9c1.1,6,2.9,12.1,5.8,19.6
                      c4.6,11.9,10.9,20.9,12,22.5l4.3,37.7l0.5,0.2c0.4,0.2,10.4,4.8,28.9,4.8c0.3,0,0.5,0,0.8,0c23-0.2,32-6.2,32.4-6.5l0.5-0.4
                      l-0.1-0.6c-3.9-25-4.1-42-4.1-44.8c1-1.4,1.9-2.8,2.9-4.2c8.9-14.3,15.8-35.6,16.8-51.9c10.3-0.2,20.7-2.1,29.1-5.4
                      c3.5,0.8,7.1,1.4,10.6,1.5l0.7,0l0.3-0.6C194.7,87.3,195.3,83.2,194.6,79.3z M125.1,50.4c1.6,6.5,5.1,12.2,10.9,17.9
                      c2,2,5.2,4.4,8.8,6.8l-22.9-3.2l4.2,3.2c2.4,1.8,4.9,3.8,7.6,5.5L111,77.1c0.6-0.4,1.1-0.9,1.7-1.4c2.4-2.3,4.5-5.8,4.5-10.1
                      c0-2.1-0.4-4.4-2.1-6.4c-0.3-0.3-0.6-0.5-0.8-0.8l0.2-0.3c7.1-8.3,11.3-18.7,11.6-28.5l11.3,26.8l-12.9-8.6L125.1,50.4z M67.2,93.5
                      l-0.1-0.6l0,0c-0.1,0-0.1,0,0,0l0,0l0,0c0.2,0.1,0.9,0.4,1.5,0.6c0.7,0.3,1.5,0.5,2.2,0.6c1.5,0.3,2.9,0.4,4.3,0.3
                      c2.7-0.2,5.1-1,6.9-2.2c1.9-1.2,3.1-2.8,4-4.2c1.7-2.9,2.1-5.1,2.5-6.7c0.3-1.5,0.4-2.4,0.4-2.8c0.2-3.1,0.2-3.3,0.2-3.3s0,0,0,0.1
                      c0.3,0.3,0.7,0.7,1.4,1.3c1.3,1,3.6,2.7,7.5,3.5l-3.6,48.7l6.2,0.1c0.1,0,0.3,0,0.5,0c1.6,0,3.5-0.6,4.2-2.3
                      c0.6-1.5-0.1-3.3-1.6-4.1c-1.3-0.7-3-0.6-4.3,0.3l1.1,1.7c0.6-0.4,1.5-0.5,2.1-0.2c0.6,0.3,0.9,1.1,0.7,1.6c-0.3,0.8-1.6,1.1-2.6,1
                      l-4.1-0.1l3.4-46.4c2.3,0.2,5-0.2,7.7-1.4c9.5,11.7,20.9,14.2,31,15.5c3.5,0.5,7.2,0.7,10.9,0.7L103.1,167l-21.8-14.4l-25.3-43.3
                      c3-0.6,5.5-2,7.3-3.6c2.1-2,3.3-4.4,3.8-6.4C67.5,97.4,67.5,95.4,67.2,93.5z M123.3,21.7c0.1,0.2,0.1,0.5,0.1,0.7l0.3,1.6h0
                      c1.5,10.1-2.1,21.8-9.4,31.2l4.5-42.8C121.4,15.2,122.7,18.9,123.3,21.7z M72.8,9.7c5.1-4.3,10.7-6.6,18.2-7.4
                      c9.5-1,18.3,1.7,25,7.6L62.6,25.3C65.4,19.1,68.2,13.6,72.8,9.7z M116.8,11.8L112,57c-1.1-0.5-2.3-0.8-3.5-1
                      c0.4,0.1,0.7,0.1,0.9,0.2c-0.5-0.1-1.7-0.3-3.3-0.3c-0.2,0-0.3,0-0.5,0l0,0c0,0,0,0,0-0.1c0,0.2,0.3-1.4,0.5-2.6
                      c0.3-2.6,0.2-5.6-0.9-8.5l0,0c-0.2-0.3-0.6-2.2-2.7-4.2c-2-2-5.5-4-9.9-4.7c-3.8-0.6-8.4-0.3-12.5,1.9c-5-4.3-10.6-7.8-16.7-10.5
                      L116.8,11.8z M109,58.3c-0.2,0-0.4-0.1-0.7-0.1C108.6,58.2,108.8,58.2,109,58.3z M76.7,37.4L13.4,26.2
                      C34.6,19.3,59.4,23.8,76.7,37.4z M77.5,39.7c-1.8,1.7-3.1,3.9-3.8,6.3c-0.4,1.4-0.6,2.8-0.7,4.2c0,0.7-0.1,1.4-0.1,2.1l0,1L72.7,53
                      l-0.5-0.4c-1.3-1.1-2.8-2.2-4.4-3c-3.2-1.6-7.1-1.9-10.4-1c-1.7,0.4-3.3,1.2-4.7,2.2c-1.4,0.9-2.6,2-3.7,3.2
                      c-1.1,1.2-2.1,2.6-2.7,4c-0.3,0.7-0.6,1.5-0.8,2.3l-0.2,1.2c-0.3,1.4-0.3,2.6-0.3,3.3c0,2.3,0.6,3.9,1.5,5.3
                      c-1.1-1.2-2.5-2.2-4.9-2.6c-1-0.2-2.7-0.3-4.8,0l-0.4,0.1l-0.5,0.1l-0.2,0L4.7,31.4l5.8-3.7L77.5,39.7z M72.9,53.2L72.9,53.2
                      L72.9,53.2L72.9,53.2L72.9,53.2z M3.2,29.7L3.2,29.7C2.5,29,2.1,28,2.1,27c-0.1-1,0.2-2,0.8-2.7c0.6-0.9,1.8-1.6,2.7-1.7
                      c2-0.3,4.4,0.7,5.4,2.5l-7.6,4.8L3.2,29.7z M4.2,34l28.3,33.4C7.9,61.3,4.6,41.3,4.2,34z M44.2,101.1L44.2,101.1L44.2,101.1
                      C44.2,101.1,44.2,101.1,44.2,101.1L44.2,101.1z M44.2,101.1C44.2,101.1,44.2,101.1,44.2,101.1L44.2,101.1z M48.6,105.6
                      c-0.3-0.2-0.6-0.5-0.8-0.9c-0.5-0.7-0.9-1.5-1.2-2.4c-0.1-0.4-0.2-0.9-0.3-1.3c-0.1-0.6,0.1-2.2,0.2-3.3c0.1-0.5-0.2-0.2-0.4-0.1
                      L45.4,98l-1.5,0.8c-0.6,0.3-0.7,0.4-1,0.4l-0.7,0.3c-2,0.6-4.2,0.8-6.3,0.2c-3.2-0.7-5.8-3.9-5.2-7.4c0.2-1.7,1.1-3.4,2.4-4.7
                      c0.3-0.3,0.6-0.7,1-1c0.1-0.1,0.7-0.5,1.1-0.8l1.3-0.9c0.4-0.3,1-0.6,1.3-0.9l-1.6-0.4l-1.6-0.5c-0.3-0.1-0.5-0.1-0.8-0.2l-0.4-0.2
                      c-1.7-0.7-3.1-2-3.6-3.7c-0.3-0.8-0.3-1.7-0.2-2.6c0.1-0.9,0.4-1.8,0.8-2.7c0.8-1.6,2.1-2.8,3.9-3.5c0.4-0.2,0.8-0.3,1.2-0.4
                      l1.7-0.4l0,0c1.7-0.3,3.2-0.1,3.9,0c2.8,0.5,4.4,1.5,7,2.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.9-2.7-1.1-4.4-1.2-7.4c0-0.6,0.1-1.7,0.3-3
                      l0.2-1.1c0.2-0.6,0.4-1.3,0.6-1.9c0.6-1.2,1.4-2.4,2.4-3.5c2-2.1,4.5-4,7.4-4.8c2.9-0.8,6.2-0.5,8.9,0.9c1.4,0.7,2.7,1.7,3.9,2.7
                      l0.5,0.4l0.7,0.7l1.9,1.8l0.9,0.9l0.5,0.5l0-0.6l-0.1-2.6L75,53.2l0-1c0-0.7,0-1.3,0.1-2c0.1-1.3,0.3-2.6,0.6-3.7
                      c0.7-2.4,2.1-4.5,3.9-6c0.2-0.2,0.5-0.3,0.8-0.5l0.2,0l0.1-0.2c3.7-2.2,8.2-2.6,11.7-2c4,0.6,7.1,2.4,8.7,4.1
                      c1.7,1.7,2.1,3.2,2.2,3.5l0,0c1,2.5,1,5.2,0.7,7.5c-0.2,1.2-0.3,1.9-0.9,4.2c-0.1,0.5-0.2,0.9-0.4,1.4c0,0-0.1,0.1,0,0.1l0.2,0
                      l0.4-0.1l0.7-0.1c0.5-0.1,1-0.2,1.4-0.2c0.3,0,0.4-0.1,0.5-0.1l0.3,0c0.9,0,1.5,0,2.1,0.1c1.3,0.2,2.5,0.6,3.5,1.1l0.4,0.2l0,0
                      c0.5,0.3,0.9,0.7,1.3,1.1c1.1,1.3,1.6,3.3,1.5,5c0,3.6-1.7,6.6-3.8,8.6c-4.4,4.1-9.5,4.5-12.8,3.9C95,77.4,93,75.9,91.8,75
                      c-0.6-0.5-1-0.9-1.2-1.1c-0.4-0.4-0.7-0.8-0.7-0.8c0,0,0,0-0.3-0.4c-0.2-0.4-0.6-0.8-1.5-2.2c-0.4-0.6-0.9-1.4-1.5-2.3
                      c-0.2-0.4-0.1-0.1-0.1,0.2c0,0.3,0,0.5,0.1,0.8c0.1,0.6,0.1,1.2,0.2,1.9c0.1,0.7,0.1,1.5,0.2,2.3c0,0.7,0,1.4,0.1,2.2
                      c0,0.9,0,1.8-0.2,2.8c0,0.3-0.1,1.1-0.4,2.6c-0.3,1.4-0.8,3.5-2.2,6c-0.8,1.2-1.7,2.5-3.3,3.5c-1.6,1-3.6,1.7-5.9,1.9
                      c-1.2,0.1-2.4,0-3.7-0.3c-0.6-0.2-1.3-0.3-2-0.6c-0.7-0.3-1-0.3-2.8-1.3c-0.7-0.4-1.4-0.8-2.2-1.2l-1.1-0.6c0,0-0.3-0.2-0.2,0
                      l0.1,0.3l0.3,0.6c0.3,0.8,0.8,1.9,1.1,2.7c0.1,0.4,0.3,0.9,0.4,1.3l0.1,0.6c0.3,1.5,0.2,3.2-0.2,4.9c-0.4,1.7-1.4,3.7-3.2,5.3
                      c-1.8,1.7-4.4,3.1-7.6,3.3c-1.5,0.1-3.1-0.3-4.5-1.2C49.3,106.1,49,105.9,48.6,105.6z M134.4,193.7l-23.6-21.3
                      c7.5-4.8,14.3-11.1,19.9-18.3C130.9,160.1,131.5,174.3,134.4,193.7z M133.8,146.1c-6.5,10.4-15.2,19.1-25.3,25.3l-1.2,0.7
                      l26.6,24.1c-3,1.6-12.3,5.4-30.1,5.5c-16.2,0.2-26-3.5-28.3-4.4l-4.2-37.1l-0.2-0.2c-0.1-0.1-7-9.5-11.9-22.2
                      c-2.9-7.4-4.7-13.3-5.7-19.2c-0.4-2.4-0.8-5.4-1.2-9c0.4,0.1,0.8,0.1,1.3,0.1l25.9,44.2l24.1,16l46.4-71.7
                      C148.5,113.8,142.1,132.9,133.8,146.1z M191.5,89.3c-3.3-0.2-6.6-0.7-9.9-1.5l-0.3-0.1l-0.3,0.1c-11.9,4.8-28,6.6-42.1,4.7
                      c-11.7-1.6-20.7-4.5-28.6-13.5l36,5.6l-6.8-3.1c-3.5-1.6-7-4.1-10.3-6.6l25.1,3.5l-4.4-2.6c-5.1-3-9.9-6.5-12.6-9.1
                      c-4.8-4.7-7.8-9.2-9.6-14.2l14,9.3l-16.3-38.6c15.7-6.1,32.9-8.4,49.6-6.6c-1.2,19.1-11.7,37.6-27.7,48.5l-1.3,0.9l27.7,18.5
                      l6.9,1.6l0.3-0.1c1.7-0.8,3.5-1.4,5.2-2.1c2.1-0.8,4.3-1.6,6.5-2.7C193,83.9,192.6,86.7,191.5,89.3z"/>
                    <path d="M109.5,56.2c0,0,0.1,0,0.2,0C110,56.3,109.9,56.3,109.5,56.2z"/>
                    <polygon points="67.1,92.9 67.1,92.9 67.1,92.9 67.1,92.9"/>
                    <path d="M91.8,147.4c0.5,1.5,1.3,3.4,4.1,4.4c0.8,0.3,1.6,0.4,2.6,0.4c0.3,0,0.7,0,1.1,0c1.9-0.2,3.6-1,4.8-2.6
                      c1.3-1.7,2-4,1.9-6.4l7.2,0l-0.4-1.3c-0.9-2.9-2.9-6.5-5.9-7.5c-2.7-1-5.8-0.2-7.5,1.8c-2.1-2-5.6-2.3-8.1-1.3
                      c-2.7,1-4.6,3.6-6.4,5.9l-1.9,2.5l8.1,0C91.3,144.6,91.4,146,91.8,147.4z M102.8,148.3c-0.9,1.1-2,1.7-3.4,1.8
                      c-0.4,0-1.8,0.1-2.9-0.2c-1.8-0.6-2.4-1.7-2.8-3.1h0c-0.3-1.1-0.4-2.2-0.4-3.4l11-0.1C104.4,145.2,103.8,147,102.8,148.3z
                      M92.3,136.8c0.7-0.3,1.5-0.4,2.3-0.4c1.7,0,3.4,0.6,4.3,2l1,1.6l0.8-1.6c0.9-1.9,3.6-2.8,5.9-2c1.8,0.7,3.3,2.8,4.1,4.9l-23.3,0.1
                      C88.8,139.4,90.4,137.5,92.3,136.8z"/>
                  </g>
                </svg>
                        </div>
                        <p class="about__text">
                            Malwina Wachulec - foodstylist&amp;photographer, born in 1989.<br>
                            Graduated at The Leon Schiller National Film, Television and Theatre School in Poland. <br>
                            Represented by Bluebird Artists  <br> <a href="https://bluebirdartists.com/pl" target="_blank" rel="nofollow">https://bluebirdartists.com/pl</a> <br><br>

                            Iʼm based in Warsaw, but I love to work worldwide :)
                        </p>
                        <div class="about__text">
                <span class="text--strong">
                  clients
                </span>
                            <div class="about__list">
                                <div class="about__list-1">
                                    Hochland <br>
                                    Lisner<br>
                                    Lidl<br>
                                    IKEA Polska<br>
                                    ORLEN<br>
                                    Barry Callebaut<br>
                                    Dr Oetker<br>
                                    Kik Fit Bar<br>
                                    Pizza Hut <br>
                                    Zielona Budka
                                </div>
                                <div class="about__list-2">
                                    One Day More <br>
                                    Wyborowa <br>
                                    MK Cafe <br>
                                    Mokate <br>
                                    Amica <br>
                                    Primo Gusto <br>
                                    Morliny <br>
                                    Olej Kujawski <br>
                                    Olej Wielkopolski <br>
                                    Iga Sarzyńska
                                </div>
                            </div>
                        </div>
                        <p class="about__text">
                <span class="text--strong">
                  contact
                </span>
                            malwinawachulec@gmail.com <br>
                            +48 724 445 465
                        </p>
                        <p class="about__text"><span class="text--strong">
                manager
              </span>
                            Natalia Starowieyska <br>
                            natalia@bluebirdartists.com <br>
                            +48 608 098 958
                        </p>
                        <!-- </div> -->
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <!-- <malwina></malwina> -->
                        <img src="./assets/malwina.jpg" class="about__img" alt="">
                    </div>
                </div>
                <div class="about__close" @click="closeAbout">
                    <closeAbout class="icon"></closeAbout>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import 'swiper/dist/css/swiper.css'
  import './css/style.css'
  import SomeIcon from './assets/logo.svg'
  import closeAbout from './assets/close.svg'
  import {TweenMax} from 'gsap'
  // import router from './router'
  const BASE_URL = process.env.BASE_URL

  export default {
    name: 'App',
    components: {
      SomeIcon,
      closeAbout
    },
    data() {
      return {
        routeName: this.$route.name,
        about: {
          content: null,
          clients1: null,
          clients2: null
        }
      }
    },
    watch: {
      '$route'(to, from) {
        if (from.name === 'Portfolio') {
          console.log(from)
          TweenMax.staggerTo(
            '.swiper-scrollbar',
            0.8,
            {
              opacity: 1
            },
            1
          )
        }
      }
    },
    methods: {
      getAbout() {
        let url = BASE_URL + '/wp-json/wp/v2/pages/109'

        try {
          axios.get(url).then(res => {
            this.about.content = res.data.acf.about_content
            this.about.clients1 = res.data.acf.about_clients_1
            this.about.clients2 = res.data.acf.about_clients_2
          })
          // this.posts = response.data
        } catch (e) {
          this.errors.push(e)
        }
      },
      openAbout(event) {
        // console.log(event)
        let about = document.querySelector('.about')
        about.style.display = 'block'
        TweenMax.staggerFrom(
          '.about',
          1,
          {
            y: [30, 0],
            scale: 1.05,
            opacity: 0
          },
          0.5
        )
      },
      closeAbout(event) {
        let about = document.querySelector('.about')
        TweenMax.staggerTo(
          '.about',
          1,
          {
            scale: 1,
            opacity: 0,
            onComplete: () => {
              about.style.display = 'none'
              about.style.opacity = ''
              about.style.transform = ''
            }
          },
          0.5
        )
      }
    },
    created: function () {
      this.getAbout()
    }
  }
</script>

<style>
    /* @import url('css/style.css'); */
</style>



// WEBPACK FOOTER //
// src/App.vue